export default "__VITE_ASSET___sjDezW2__"